import { render, staticRenderFns } from "./ForgotPw.vue?vue&type=template&id=439e1794"
import script from "./ForgotPw.vue?vue&type=script&lang=js"
export * from "./ForgotPw.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports